/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

interface ClientAvatarProps {
  fullName: string;
  size?: number;
  /** Background color override (e.g. `var(--accent-*)`). Defaults to the brand seed color. */
  accentColor?: string;
}

/**
 * Derives up-to-two uppercase initials from a person's full name.
 *
 * @param fullName - The client's full name (may contain multiple words).
 * @returns The first letters of the first two words, uppercased.
 */
function getInitials(fullName: string): string {
  const words = fullName.trim().split(/\s+/);
  if (words.length === 0) return "";
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
}

export default function ClientAvatar({ fullName, size = 32, accentColor }: ClientAvatarProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: "50%",
        background: accentColor ?? "var(--seed-base)",
        color: "var(--button-primary-text)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.4,
        fontWeight: 600,
        fontFamily: "var(--font-family)",
      }}
    >
      {getInitials(fullName)}
    </div>
  );
}
